export const RECORDS_ROUTES = {
  __ROOT__: '/records',
  VIEW_RECORD: '/records/view/:recordId',
}

export type RecordFieldOption = {
  label: string
  value: string
}
